import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hideSuccess } from '../../../redux/actions/snackbarActions';
import { Snackbar, SnackbarContent, IconButton, Icon, Typography } from '@material-ui/core';
import { instajobTheme } from '../../helpers/instajobTheme';

class SuccessSnackbar extends Component {
    render() {
        const { message, show, hideSuccess } = this.props;
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={show}
                autoHideDuration={6000}
                onClose={hideSuccess}>
                <SnackbarContent
                    aria-describedby="client-snackbar"
                    style={{ backgroundColor: instajobTheme.palette.primary.main }}
                    message={
                        <Typography variant="body1" style={{ padding: 0 }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Icon style={{marginRight: 15}}>done</Icon>
                                {message}
                            </div>
                        </Typography>
                    }
                    action={[
                        <IconButton key="close" aria-label="Close" color="inherit" onClick={hideSuccess}>
                            <Icon>close</Icon>
                        </IconButton>
                    ]}
                />
            </Snackbar>
        );
    }
}

const mapSuccessStateToProps = store => ({
    message: store.snackbarState.message.success,
    show: store.snackbarState.show.success
});

const mapSuccessActionsToProps = dispatch => (
    bindActionCreators({ hideSuccess }, dispatch)
);

export default connect(mapSuccessStateToProps, mapSuccessActionsToProps)(SuccessSnackbar);